import {createFeatureSelector, createSelector} from '@ngrx/store';
import {initialPastTermRegistrationsState, PastTermRegistrationsState} from './past-term-registrations.state';
import {ServiceStatus} from "../../../shared/model/service-registration.model";

export const selectPastTermRegistrationsState = createFeatureSelector<PastTermRegistrationsState>('past-term-registrations');

export const selectAllPastTermRegistrations = createSelector(
  selectPastTermRegistrationsState,
  (state) => state.registrations
);

export const selectNewPastTermRegistrations = createSelector(
  selectAllPastTermRegistrations,
  (registrations) => registrations.filter(reg => reg.status === ServiceStatus.REGISTERED)
);

export const selectDeniedPastTermRegistrations = createSelector(
  selectPastTermRegistrationsState,
  (state: PastTermRegistrationsState) => state.registrations.filter(reg => reg.status === ServiceStatus.DENIED)
);

export const selectApprovedPastTermRegistrations = createSelector(
  selectPastTermRegistrationsState,
  (state: PastTermRegistrationsState) => state.registrations.filter(reg => reg.status === ServiceStatus.PASSED)
);

export const selectPendingAdminApprovalPastTermRegistrations = createSelector(
  selectPastTermRegistrationsState,
  (state: PastTermRegistrationsState) => state.registrations.filter(reg => reg.status === ServiceStatus.PAST_REGISTRATION_PENDING_ADMIN_REVIEW)
);


export const selectLoading = createSelector(
  selectPastTermRegistrationsState,
  (state) => state.loading
);
